module.exports = __webpack_public_path__ + "img/74.6fa151c9.svg";